import { lazy } from 'react';

const Dashboard = lazy(() => import('./DashboardPage'));

const MerchantDashboardConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/merchant/dashboard',
      element: <Dashboard />,
    },
  ],
};

export default MerchantDashboardConfig;
